import { Routes, Route } from 'react-router-dom';

import LoginPage from './pages/login/AdminLoginPage';
import AdminPage from './pages/admin/AdminPage';
import ProtectedRoute from './components/protected/ProtectedRoute';

import './app.css';

function App() {
  return (
    <div>
      <main className="main-content">
        <Routes>
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;